import Events from 'events';

import S3Upload from 'react-s3-uploader/s3upload';

const { EventEmitter } = Events;

class S3FileUploader {
  constructor(file, options) {
    this.file = file;
    this.emitter = new EventEmitter();
    this.opts = options || {};
  }

  getFile() {
    return this.file;
  }

  on(event, callback) {
    this.emitter.addListener(event, callback);
  }

  cancel() {
    if (this.upload) {
      this.upload.abortUpload();
      this.emitter.emit('abort');
      this.upload = null;
    }
  }

  markFailed(status) {
    this.failed = true;
    this.error = status;
  }

  isFailed() {
    return !!this.failed;
  }

  getContentDisposition() {
    return this.file.type === 'application/pdf' ? 'inline' : 'auto';
  }

  start() {
    return new Promise((resolve, reject) => {
      this.upload = new S3Upload({
        files: [this.file],
        signingUrl: this.opts.signingUrl,
        signingUrlMethod: this.opts.signingUrlMethod,
        accept: this.opts.accept,
        uploadRequestHeaders: this.opts.uploadRequestHeaders,
        signingUrlQueryParams: this.opts.signingUrlQueryParams,
        scrubFilename: this.opts.scrubFilename,
        server: this.opts.server,
        contentDisposition: this.getContentDisposition(),
        onProgress: (percent, status) => {
          this.emitter.emit('progress', percent, status);
        },
        onFinishS3Put: result => {
          this.result = result;
          this.emitter.emit('complete', result);
          resolve(result);
        },
        onError: status => {
          this.emitter.emit('error', status);
          this.markFailed(status);
          reject(status);
        },
      });
      this.emitter.once('abort', resolve);
    });
  }
}

export default S3FileUploader;
